
import * as types from '../../mutation-types'
import {setItems} from '../../../util/helpers'
import merge from 'deepmerge'

export default function (appUser) {
  const state = merge({
    clubId: 0,
    staffId: 0,
    club: '',
    clubName: '',
    name: '',
    username: '',
    userType: '',
    email: '',
    landingPage: '',
    reservationIssueCount: 0,
    gender: '',
    isForeTeeUser: false,
    isStaff: false,
    // isDining: false,
    // isPos: false,
    // isProshop: false,
    // isAdmin: false,
    isSupport: false,
    isMember: false,
    intercomHashId: '',
    userToken: null,
    usesPin: false,
    clockedIn: null,
    apps: {
      dining: false,
      pos: false,
      admin: false,
      proshop: false,
      support: false
    },
    acv: null, // App configuration version
    photoUrl: null,
    access: {
      // dining: false,
      // pos: false,
      superAdmin: false,
      manageClubSettings: false,
      manageStaff: false,
      manageEvents: false,
      manageReservations: false,
      viewReservations: false,
      manageBlockers: false,
      manageMealPeriods: false,
      manageOccasions: false,
      manageKitchens: false,
      manageLocations: false,
      manageGuests: false,
      reports: false,
      manageMemberPrefs: false,
      adminMemberPayments: false,
      adminAcceptPayments: false,
      viewLessonBooks: false,
      configLessonBooks: false,
      updateLessonBooks: false,
      registerTerminal: false,
      restrictedTerminal: false,
      allowSupportFullAccess: false,
      editEventCategories: false,
      disabled: false
    }
  }, appUser)

  const mutations = {
    [types.SET_USER] (state, userRecord) {
      setItems(state, userRecord)
    }
  }

  return {
    state,
    mutations
  }
}
